/* use 'module.exports' syntax so that this can also be used by node */
module.exports = {
  production: 'https://39c50e1ab07141e4984afe0d080e5b44@sentry.io/1460411',
  staging: 'https://da9296f65b2b4b8bbced1ad56066fbd7@sentry.io/1460408'
};



// WEBPACK FOOTER //
// ./common/sentry_dsns.js